import { gql, makeVar, type TypePolicies, useQuery } from '@apollo/client'
import { config } from '@backoffice-frontend/common'
import { HubFilterOptions } from '../useSelectedServiceArea'

export type SelectedHub = string | HubFilterOptions

export const GET_SELECTED_HUB = gql`
  query getSelectedHub {
    getSelectedHub @client {
      id
    }
  }
`

export const useGlobalHubId = (): SelectedHub => {
  const { data } = useQuery(GET_SELECTED_HUB)

  return data.getSelectedHub.id ?? HubFilterOptions.ALL
}

export const selectedHubVar = makeVar<SelectedHub | undefined>(
  config.getHubId(),
)

export const selectHub = (hub?: SelectedHub) => {
  const currentHub = selectedHubVar()
  if (hub === currentHub) {
    return
  }

  config.setHubId(hub)
  selectedHubVar(hub)
}

type SelectedHubQuery = {
  id?: SelectedHub
}

export const MoiaSelectedHubTypePolicies: TypePolicies = {
  Query: {
    fields: {
      getSelectedHub: {
        read(): SelectedHubQuery {
          return { id: selectedHubVar() }
        },
      },
    },
  },
}
